import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { setSearchDataModeActive } from "@insite/client-framework/Store/Context/ContextActionCreators";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonProps } from "@insite/mobius/Button";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import DatePicker, { DatePickerState } from "@insite/mobius/DatePicker/DatePicker";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Tag, { horizontalStyles, TagPresentationProps } from "@insite/mobius/Tag";
import TextField from "@insite/mobius/TextField/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import loadViewData from "@tSurya/Handlers/ViewReturnData";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { SurFilterDataModel } from "@tSurya/Store/Data/CustomApplicationState/CustomDataState";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const StyledForm = getStyledWrapper("form");
type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        state,
        serachedParameter: state.SURData.viewDataStore.searchparameter,
    };
};

const mapDispatchToProps = {
    loadViewData,
};

export interface ViewReturnFilterFormStyles {
    wrapper?: InjectableCss;
    headingText?: TypographyPresentationProps;
    container?: GridContainerProps;
    button?: InjectableCss;
    textField?: InjectableCss;
    dateField?: GridItemProps;
    nowButton?: InjectableCss;
    buttonsItem?: GridItemProps;
    clearFiltersButton?: ButtonProps;
    appliedFiltersContainer?: InjectableCss;
    appliedFilterTag?: TagPresentationProps;
}

export const searchFormStyles: ViewReturnFilterFormStyles = {
    wrapper: {
        css: css`
            margin-bottom: 10px;
            margin-top: -34px;
        `,
    },
    headingText: { variant: "h5" },
    container: {},
    button: {
        css: css`
            padding-top: 23px;
        `,
    },
    nowButton: {
        css: css`
            white-space: nowrap;
            margin-top: 22px;
            margin-left: 10px;
        `,
    },
    dateField: {
        width: [12, 12, 6, 4, 4],
        css: css`
            align-items: center;
            > div:first-child {
                width: 89%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            div[class^="FormFieldStyle"] {
                width: 100%;

                label {
                    font-family: "Mulish";
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: ${TYPOGRAPHY.lineHeight.base};
                    color: ${getColor("text.main")};
                }
            }
            .react-datetime-picker {
                height: 40px;
                /* z-index: 9 !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            z-index: auto !important;
                        `,
                        css`
                            z-index: auto !important;
                        `,
                        null,
                        null,
                        null,
                    ])} */

div[class^="react-calendar"] {
                        width: 100% !important;
                    }
            }
            div[class^="FormInputWrapper"] .react-datetime-picker__clear-button svg {
                margin-bottom: -4px;
        }
        `,
    },

    textField: {
        css: css`
            div[class^="FormFieldStyle"] {
                label {
                    font-family: ${TYPOGRAPHY.fontFamily.title};
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: ${TYPOGRAPHY.lineHeight.base};
                    color: ${getColor("text.main")};
                }
            }

            div[class^="FormInputWrapper"] {
                input {
                    background: ${getColor("common.background")};
                    border: 1px solid ${getColor("common.border")} !important;
                }
            }
        `,
    },
    buttonsItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    clearFiltersButton: {
        variant: "secondary",
        css: css`
            margin-right: 10px;
        `,
    },
    appliedFiltersContainer: { css: horizontalStyles },
    appliedFilterTag: {
        css: css`
            background-color: ${getColor("text.main")};
            border: 1px solid ${getColor("primary")};
            border-radius: unset;
            span[class^="TypographyStyle"] {
                display: flex;
                flex-direction: column;
                justify-content: center;
                color: ${getColor("primary.contrast")};
                text-transform: capitalize;
            }
            :hover {
                background: ${getColor("text.accent")};
            }
            /* > button {
                :hover {
                    background: transparent;
                }
                background: transparent;
                span[class^="IconWrapper"] {
                    > svg {
                        color: ${getColor("primary.contrast")};
                    }
                }
            } */
        `,
    },
};

const styles = searchFormStyles;

const SurViewReturnFilterForm: React.FunctionComponent<Props> = ({ loadViewData, state, serachedParameter }) => {
    // const filterSearchParams: StoreParameter = serachedParameter;
    const tzOffset = new Date().getTimezoneOffset() * 60000;
    const [rmaNumber, setRmaNumber] = React.useState("");
    const [beginDate, setBeginDate] = React.useState<string>();
    const [endDate, setEndDate] = React.useState<string>();

    const [data, setData] = React.useState<SurFilterDataModel>();

    const fieldRemoveHandler = (fieldName: string, value = "") => {
        const updatedParams: any = { ...serachedParameter };
        value === rmaNumber && setRmaNumber("");
        value === beginDate && setBeginDate("");
        value === endDate && setEndDate("");
        delete updatedParams[fieldName];
        loadViewData({ ...updatedParams });
    };

    React.useEffect(() => {
        setData(state?.SURData?.surFilterDataStore);
    }, [state?.SURData?.surFilterDataStore]);

    const updatestartDate = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        // const updateStartDate = selectedDay
        //     ? new Date(selectedDay.getTime() - tzOffset).toISOString().split("T")[0]
        //     : "";
        const updateStartDate = selectedDay
            ? new Date(selectedDay).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
              })
            : "";
        loadViewData({ ...serachedParameter, beginDate: updateStartDate, page: 1 });
        setBeginDate(updateStartDate);
    };
    const updateendDate = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        // const updateEndDate = selectedDay ? new Date(selectedDay.getTime() - tzOffset).toISOString().split("T")[0] : "";
        const updateEndDate = selectedDay
            ? new Date(selectedDay).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
              })
            : "";
        loadViewData({ ...serachedParameter, endDate: updateEndDate, page: 1 });
        setEndDate(updateEndDate);
    };

    const UpdateRMA = (e: React.ChangeEvent<HTMLInputElement>) => {
        loadViewData({ ...serachedParameter, rmaNumber: e.target.value, page: 1 });
        setRmaNumber(e.target.value);
    };
    const handleBeginDateNow = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const current: Date = new Date();
        // const newDate = current ? new Date(current.getTime() - tzOffset).toISOString().split("T")[0] : "";
        const newDate = current
            ? new Date(current).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
              })
            : "";
        loadViewData({ ...serachedParameter, beginDate: newDate });
        setBeginDate(newDate);
    };

    const handleEndDateNow = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const current: Date = new Date();
        // const newDate = current ? new Date(current.getTime() - tzOffset).toISOString().split("T")[0] : "";
        const newDate = current
            ? new Date(current).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
              })
            : "";
        setEndDate(newDate);
        loadViewData({ ...serachedParameter, endDate: newDate });
    };
    const clearFiltersClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setRmaNumber("");
        setBeginDate("");
        setEndDate("");
        loadViewData({});
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            {data?.surfiltersOpen ? (
                <>
                    <StyledWrapper>
                        <StyledForm>
                            <GridContainer {...styles.container}>
                                <GridItem {...styles.dateField}>
                                    <DatePicker
                                        label={translate("Date Range")}
                                        selectedDay={beginDate ? new Date(beginDate) : undefined}
                                        onDayChange={updatestartDate}
                                        dateTimePickerProps={{
                                            clearIcon: beginDate ? undefined : null,
                                        }}
                                    />
                                    {/* <Link {...styles.nowButton} onClick={handleBeginDateNow}>
                                        {translate("Now")}
                                    </Link> */}
                                </GridItem>

                                <GridItem {...styles.dateField}>
                                    <DatePicker
                                        label=" "
                                        selectedDay={endDate ? new Date(endDate) : undefined}
                                        onDayChange={updateendDate}
                                        dateTimePickerProps={{
                                            clearIcon: endDate ? undefined : null,
                                        }}
                                    />
                                    {/* <Link {...styles.nowButton} onClick={handleEndDateNow}>
                                        {translate("Now")}
                                    </Link> */}
                                </GridItem>
                                <GridItem {...styles.dateField}>
                                    <TextField
                                        id="SKU"
                                        label={translate("Return Request No")}
                                        placeholder={translate("Enter Return Request No.")}
                                        value={rmaNumber}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            UpdateRMA(e);
                                        }}
                                    />
                                </GridItem>
                                <GridItem {...styles.buttonsItem}>
                                    <Button
                                        {...styles.clearFiltersButton}
                                        onClick={clearFiltersClickHandler}
                                        data-test-selector="creditMemo_clearFiltersButton"
                                    >
                                        {translate("Clear Search")}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                        </StyledForm>
                    </StyledWrapper>
                </>
            ) : Object.entries(serachedParameter).length ? (
                <StyledWrapper {...styles.appliedFiltersContainer}>
                    {Object.entries(serachedParameter)
                        .filter(([key, value]) => key !== "page" && key !== "sort" && key !== "pageSize" && value)
                        .map(([key, value]) => (
                            <Tag
                                {...styles.appliedFilterTag}
                                key={value}
                                onDelete={() => {
                                    fieldRemoveHandler(key, value);
                                }}
                            >
                                {key === "rmaNumber"
                                    ? `Return Request #: ${value}`
                                    : `${key.split(/(?=[A-Z])/).join(" ")}: ${value}`}
                            </Tag>
                        ))}
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SurViewReturnFilterForm),
    definition: {
        group: "Basic",
        displayName: "SurViewReturnFilterForm",
    },
};

export default widgetModule;
